import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { PlexEnvironment } from "@app/env";
import { ProjectEstimateDetailItemUpsertDto } from "@app/shared/models/dtos/project-estiamte-detail-item-upsert";
import { ProjectEstimateDetailDto } from "@app/shared/models/dtos/project-estimate-detail";
import { ProjectEstimateDetailItemDto } from "@app/shared/models/dtos/project-estimate-detail-item";

@Injectable({
  providedIn: "root",
})
export class ProjectEstimateDetailService {
  private http = inject(HttpClient);
  public environment = inject(PlexEnvironment);

  private BASE_URL: string;

  constructor() {
    this.BASE_URL = this.environment.apiUrl;
  }

  public async GetProjectEstimateItems(projectId: number, estimateVersion: number, projectEstimateStatusId: number | null, compareEstimate: boolean): Promise<ProjectEstimateDetailDto> {
    let url = `${this.BASE_URL}ProjectEstimateDetail/GetProjectItemDetails/${projectId}/${estimateVersion}/${compareEstimate}`;
    if (projectEstimateStatusId !== null) {
      let query = `?projectEstimateStatusId=${projectEstimateStatusId}`;
      url = url + query;
    }
    let eResponse = await this.http.get<ProjectEstimateDetailDto>(url).toPromise();
    return eResponse;
  }

  public async UpsertProjectItem(toUpsert: ProjectEstimateDetailItemUpsertDto): Promise<ProjectEstimateDetailItemDto[]> {
    let url = `${this.BASE_URL}ProjectEstimateDetail/UpsertProjectEstimateItems`;
    let response = await this.http.post<ProjectEstimateDetailItemDto[]>(url, toUpsert).toPromise();
    return response;
  }
}